import { useUserState } from "src/components/UserState";

export const useCurrentUserId = () => {
  const userId = useUserState(
    (state) => state.userId ?? state.tempUserId ?? "",
  );
  return userId;
};
